import { createWater } from "./water";

export function initPlatformWater(reduced: boolean): void {
  const host = document.querySelector<HTMLElement>("#platform");
  const canvas = host?.querySelector<HTMLCanvasElement>("[data-section-water]");
  if (!host || !canvas) return;
  const water = createWater(canvas, host, reduced, {
    fade: [0.5, 0.35],
    wake: true,
    scrollWake: true,
  });
  host.addEventListener("water:ring", (e) => {
    const { x, y, strength, radius } = (e as CustomEvent<WaterRing>).detail;
    water?.ring(x, y, strength, radius);
  });
}

interface WaterRing {
  x: number;
  y: number;
  strength: number;
  radius: number;
}

export function initNetworkWater(reduced: boolean): void {
  const host = document.querySelector<HTMLElement>("#networks");
  const canvas = host?.querySelector<HTMLCanvasElement>("[data-section-water]");
  if (!host || !canvas) return;
  const water = createWater(canvas, host, reduced, {
    fade: [0.5, 0.5],
    wake: true,
    scrollWake: true,
  });
  if (!water) return;
  host.querySelectorAll<HTMLElement>(".use").forEach((use) => {
    const marker = use.querySelector<HTMLElement>(".cube") ?? use;
    const ring = () => {
      const r = marker.getBoundingClientRect();
      water.ring(r.left + r.width / 2, r.top + r.height / 2, -0.07, 0.05);
    };
    use.addEventListener("pointerenter", (e) => {
      if (e.pointerType === "mouse") ring();
    });
    use.addEventListener("pointerdown", (e) => {
      if (e.pointerType !== "mouse") ring();
    });
  });
}
